import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalProps,
} from 'reactstrap';

export type ReusableModalProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  onClose?: () => any;
  isOpen: boolean;
} & ModalProps;

export const ReusableModal: React.FC<ReusableModalProps> = (props) => {
  const { header, children, footer, onClose, isOpen, ...rest } = props;

  const handleToggle = () => {
    if (isOpen) {
      onClose?.();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} {...rest}>
      {header && <ModalHeader>{header}</ModalHeader>}
      <ModalBody>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  );
};
